import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class DevicepackagesHasArticle extends Model{
  static entity = 'devicepackagesHasArticles'
  static fields () {
    return {
      id: this.attr(null),
      articles_id: this.attr(null),
      default: this.attr(null),
      devicepackages_id: this.attr(null),

      article: this.belongsTo(Article, 'articles_id'),
    }
  }
}
  